import React, { useState } from 'react';

function PermissionRequest({ onSubmit }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      onSubmit(email, password);
    }
  };

  return (

    <form onSubmit={handleSubmit}>
      <p className="mb-4">You need to create credentials to download this file.</p>
      <div className="mb-3">
        <label htmlFor="email" className="form-label">Your Email:</label>
        <input
          type="email"
          className="form-control"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label htmlFor="password" className="form-label">Your Password:</label>
        <input
          type="password"
          className="form-control"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary w-100">Request Permission</button>
    </form>

  );
}

export default PermissionRequest;